import { keyframes } from '@emotion/core';

export const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;
